import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09781c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "pagination-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "filter-card",
      shadow: "never"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          class: "filter-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "解析日時" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.filterCreatedAtRange,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterCreatedAtRange) = $event)),
                  type: "daterange",
                  "range-separator": "〜",
                  "start-placeholder": "開始日",
                  "end-placeholder": "終了日",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  "first-day-of-week": 1,
                  onChange: _ctx.handleFilterChange
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "撮影日時" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.filterShotAtRange,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterShotAtRange) = $event)),
                  type: "daterange",
                  "range-separator": "〜",
                  "start-placeholder": "開始日",
                  "end-placeholder": "終了日",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  "first-day-of-week": 1,
                  onChange: _ctx.handleFilterChange
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "個体識別番号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.filterCattleId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterCattleId) = $event)),
                  placeholder: "個体識別番号",
                  clearable: "",
                  onInput: _ctx.handleFilterChange
                }, null, 8, ["modelValue", "onInput"])
              ]),
              _: 1
            }),
            (!_ctx.isFarmerUser)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "NLBC飼養者"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.filterFarmer,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterFarmer) = $event)),
                      placeholder: "NLBC飼養者",
                      clearable: "",
                      onInput: _ctx.handleFilterChange
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.applyFilters
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("適用")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.clearFilters }, {
                  default: _withCtx(() => [
                    _createTextVNode("クリア")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_component_el_table, {
      key: _ctx.tableKey,
      data: _ctx.predictions,
      style: {"width":"100%"},
      "default-sort": _ctx.tableSort,
      onSortChange: _ctx.handleSortChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "createdAt",
          label: "解析日時",
          sortable: "custom"
        }),
        (!_ctx.isFarmerUser)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              fixed: "",
              prop: "user.name",
              label: "ユーザー名"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "cattleId",
          label: "個体識別番号"
        }),
        (!_ctx.isFarmerUser)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              fixed: "",
              prop: "farmer",
              label: "NLBC飼養者"
            }))
          : _createCommentVNode("", true),
        (!_ctx.isFarmerUser)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              fixed: "",
              prop: "managerDisplayName",
              label: "飼養管理者"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "shotAt",
          label: "撮影日時",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "result.BMS",
          label: "推定BMS",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "hasCarcass"
        }, {
          header: _withCtx(() => [
            _createTextVNode(" 枝肉DB情報 ")
          ]),
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.hasCarcass ? '有' : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          width: "100"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadCsv())),
              icon: _ctx.Download,
              class: "export-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("csv")
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          default: _withCtx((scope) => [
            _createVNode(_component_router_link, {
              to: { name: 'Detail', params: { id: scope.row.id } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { size: "default" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 詳細 ")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "default-sort", "onSortChange"])),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        "current-page": _ctx.currentPage,
        "onUpdate:current-page": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentPage) = $event)),
        "page-size": _ctx.perPage,
        "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.perPage) = $event)),
        "page-sizes": [10, 20, 50, 100],
        total: _ctx.pagination?.total || 0,
        layout: "total, sizes, prev, pager, next, jumper",
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
    ])
  ]))
}